import { RoleBadge } from '@/modules/administration/components/RoleBadge';
import type { Role } from '@/modules/auth/roles';
import { Button } from '@/modules/ui/components/button/Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/modules/ui/components/dialog/Dialog';
import type { UserApi } from '@/modules/users/types';

interface ManageRolesDialogProps {
  user: UserApi | null;
  onClose: () => void;
  onRemove: (userId: string, role: Role) => void;
}

export const ManageRolesDialog = ({
  user,
  onClose,
  onRemove,
}: ManageRolesDialogProps) => {
  return (
    <Dialog open={!!user} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            Manage Roles for {user?.firstName} {user?.lastName}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-wrap gap-2 py-4">
          {user?.roles?.map((role) => (
            <RoleBadge
              key={role}
              role={role as Role}
              user={user}
              onRemove={onRemove}
            />
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
